const $ = window.$;
let _$outer = $('#microNav');
let _isOpen = false;
const _HIDE_WIDTH = 768;

function _toggle() {
	_isOpen = !_isOpen;
	if (!_$outer.hasClass('a-fadeIn')) {
		_$outer.addClass('a-fadeIn');
	}

	if (_isOpen) {
		_$outer
			.show()
			.addClass('animate');
	} else {
		_$outer
			.removeClass('animate')
			.delay(200).queue(function() {
				$(this).hide();
				$(this).dequeue();
			});
	}
}

function _attachEvents() {
	$(document).on('click', '.js-micronav-toggle', function() {
		_toggle();
	});

	$(document).on('click', '.js-micronav-logout', function() {
		window.location.href = 'Logout.aspx';
	});

}

function _cacheSelectors() {
	_$outer = $('#microNav');
}

export function init() {
	_cacheSelectors();
	_attachEvents();
}

export function handleResize() {
	if (_isOpen && window.currentWindowWidth > _HIDE_WIDTH) {
		_toggle();
	}
}